import React from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Text,
} from "@chakra-ui/react";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size={{ base: "xs", md: "md" }}>
            <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(2px)" />
            <ModalContent borderRadius="xl">
                <ModalHeader borderBottomWidth="1px" py={4} fontSize="xl" fontWeight="600">
                    Confirmation Alert!
                </ModalHeader>
                <ModalCloseButton mt={2} />
                <ModalBody py={6}>
                    <Text fontSize="md" color="gray.600">
                        {message}
                    </Text>
                </ModalBody>
                <ModalFooter borderTopWidth="1px" py={4}>
                    <Button
                        bg="#0f172a"
                        color="white"
                        _hover={{ bg: "#020617" }}
                        mr={3}
                        onClick={onClose}
                        px={8}
                        borderRadius="md"
                    >
                        No
                    </Button>
                    <Button
                        bg="#4f46e5"
                        color="white"
                        _hover={{ bg: "#4338ca" }}
                        px={8}
                        borderRadius="md"
                        onClick={onConfirm}
                    >
                        Yes
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ConfirmationModal;
